import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { apiClient } from "@/lib/api/client";
import { useAuthStore } from "@/lib/auth/store";

export function useLogout() {
  const clear = useAuthStore((s) => s.clear);
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      const refreshToken = useAuthStore.getState().refreshToken;
      if (refreshToken) {
        // fire-and-forget — don't block logout on server response
        apiClient.post("/v1/auth/logout", { refreshToken }).catch(() => undefined);
      }
    },
    onSettled: () => {
      clear();
      void navigate({ to: "/login" });
    },
  });
}
